import { render, staticRenderFns } from "./main_layouts.vue?vue&type=template&id=675e9e14&scoped=true&"
import script from "./main_layouts.vue?vue&type=script&lang=js&"
export * from "./main_layouts.vue?vue&type=script&lang=js&"
import style0 from "./main_layouts.vue?vue&type=style&index=0&id=675e9e14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e9e14",
  null
  
)

export default component.exports